// @flow
import React from "react";
import type { Game, TicketReservationStatusType } from "../../common/types";
import { AuthCheck, SuspenseWithPerf } from "reactfire";
import GameDetailsFooterReserve from "./GameDetailsFooterReserve";
import GameDetailsFooterTicketOrReserve from "./GameDetailsFooterTicketOrReserve";
import ListItem from "@material-ui/core/ListItem";
import Box from "@material-ui/core/Box";
import ScheduleGameCardFooterStreamButton from "../Schedule/ScheduleGameCardFooterStreamButton";

type Props = {
  game: Game,
  ticketReservationStatus: TicketReservationStatusType,
};

function GameDetailsFooter(props: Props) {
  return (
    <ListItem>
      <Box mt={1} mb={2} style={{width: '100%', textAlign: 'center'}}>
        <ScheduleGameCardFooterStreamButton buttonProps={{size: "large"}} />
      </Box>
    </ListItem>
  );

  // noinspection UnreachableCodeJS
  return (
    <SuspenseWithPerf
      traceId="GameDetailsFooterTicketOrReserve"
      fallback={<GameDetailsFooterReserve {...props} />}
    >
      <AuthCheck fallback={<GameDetailsFooterReserve {...props} />}>
        <GameDetailsFooterTicketOrReserve {...props} />
      </AuthCheck>
    </SuspenseWithPerf>
  );
}

export default GameDetailsFooter;
